module.exports = __webpack_public_path__ + "resources/images/van_lanschot-b7ae4537710d9c36a8e470ed73a53093-cache.png";